import { ApplicationTermsOfUsePage } from '../../types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiApplicationTermsOfUsePage = (strapiData: any): ApplicationTermsOfUsePage => strapiData.attributes

export { fromStrapiApplicationTermsOfUsePage }